import TModal from './Modal.vue'

export const Modal = TModal
